import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import ModuleCard from "../components/ModuleCard";
import { modules } from "../routes.js";

const Home = () => {
  const [results, setResults] = useState([]);
  const [tags, setTags] = useState(null);

  const params = useParams();

  useEffect(() => {
    const { tag } = params;
    let listTags = [] 
    modules.forEach(element => {
        listTags = [ ...listTags, ...element.tags]
    });
    const tagName = listTags.find(f => f.url === tag)
    if(tagName) {
      setTags(tagName.name)
      const listResults = modules.filter(m => m.tags.filter(t => t.url === tag).length >= 1)
      setResults(listResults)
    }
    
    
  }, [params]);

  return (
    <>
      <div className="container container-modules py-5 mt-5">
        <h2 className="mb-3">Etiqueta {tags}:</h2>
        <div className="row gy-4">
          {results.map((m, i) => (
            <div className="col-md-4 col-12 col-sm-6" key={i}>
              <ModuleCard content={m} istag='true' />
            </div>
          ))}
        </div>
      </div>
      <footer className="bg-light p-5">
        <div className="container">
          <p className="text-center">
            Contenidos desarrollados por{" "}
            <strong>
              Carolina de Belaunde, Mariana Eguren y Natalia González (Instituto
              de Estudios Peruanos - IEP)
            </strong>
            . Ilustraciones de{" "}
            <strong>Gabriel Alayza y Mateo Alayza (Hermanos Magia)</strong>.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Home;
